import Swal from 'sweetalert2';
import HelperMixin from '../../Shared/HelperMixin.vue';

export default {
    name: 'SupportChat',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.loginDetails || this.loginDetails.userType != 1) {
            this.logout();
            return;
        }
        this.loadTickets();
        this.loadUnread();
        this.pollTimer = setInterval(() => {
            if (this.selectedTicket) this.loadMessages(false);
            this.loadUnread();
        }, 5000);
    },

    beforeDestroy() {
        if (this.pollTimer) clearInterval(this.pollTimer);
    },

    computed: {
        canSend() {
            return (this.replyText && this.replyText.trim()) || this.pendingFile;
        }
    },

    data() {
        return {
            tickets: [],
            messages: [],
            selectedTicket: null,
            replyText: '',
            pendingFile: null,
            pendingFileBase64: '',
            statusFilter: 1,
            unreadCount: 0,
            pollTimer: null,
            pageNo: 1,
            pageSize: 50
        };
    },

    methods: {
        setFilter(status) {
            this.statusFilter = status;
            this.selectedTicket = null;
            this.messages = [];
            this.loadTickets();
        },

        loadTickets() {
            this.$http.GetSupportTickets(this.pageNo, this.pageSize, this.statusFilter || null)
                .then(res => {
                    this.tickets = res.data.info || [];
                })
                .catch(() => {
                    this.tickets = [];
                });
        },

        loadUnread() {
            this.$http.GetSupportUnreadCount()
                .then(res => {
                    this.unreadCount = res.data.count || 0;
                })
                .catch(() => {
                    this.unreadCount = 0;
                });
        },

        selectTicket(ticket) {
            this.selectedTicket = ticket;
            this.replyText = '';
            this.pendingFile = null;
            this.pendingFileBase64 = '';
            this.loadMessages(true);
        },

        loadMessages(showLoader) {
            if (!this.selectedTicket) return;
            if (showLoader) this.$blockUI.Start();
            this.$http.GetSupportMessages(this.selectedTicket.roomId, 1, 100, null)
                .then(res => {
                    if (showLoader) this.$blockUI.Stop();
                    this.messages = res.data.info || [];
                    this.$nextTick(() => this.scrollToBottom());
                })
                .catch(() => {
                    if (showLoader) this.$blockUI.Stop();
                });
        },

        scrollToBottom() {
            const el = this.$refs.chatHistory;
            if (el) el.scrollTop = el.scrollHeight;
        },

        sendReply() {
            if (!this.canSend || !this.selectedTicket) return;

            const body = {
                content: this.replyText ? this.replyText.trim() : '',
                messageType: this.pendingFileBase64 ? (this.pendingFile.type.startsWith('image/') ? 2 : 3) : 1,
                attachmentBase64: this.pendingFileBase64 || null,
                attachmentName: this.pendingFile ? this.pendingFile.name : null,
                attachmentSize: this.pendingFile ? this.pendingFile.size : null
            };

            this.$blockUI.Start();
            this.$http.ReplySupportTicket(this.selectedTicket.roomId, body)
                .then(() => {
                    this.$blockUI.Stop();
                    this.replyText = '';
                    this.pendingFile = null;
                    this.pendingFileBase64 = '';
                    this.loadMessages(false);
                    this.loadTickets();
                })
                .catch(err => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'فشل الإرسال';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },

        onFileSelected(e) {
            const file = e.target.files[0];
            if (!file) return;
            if (file.size > 2 * 1024 * 1024) {
                this.$helper.ShowMessage('error', 'خطأ', 'الحد الأقصى للملف 2MB');
                e.target.value = '';
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                this.pendingFile = file;
                this.pendingFileBase64 = reader.result;
            };
            reader.readAsDataURL(file);
        },

        closeTicket() {
            Swal.fire({
                title: 'إغلاق التذكرة',
                text: 'هل أنت متأكد من إغلاق هذه التذكرة؟',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'إغلاق',
                cancelButtonText: 'إلغاء',
                customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-secondary ms-2' },
                buttonsStyling: false
            }).then(result => {
                if (!result.isConfirmed) return;
                this.$blockUI.Start();
                this.$http.CloseSupportTicket(this.selectedTicket.id)
                    .then(res => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('success', 'تم', res.data);
                        this.selectedTicket.ticketStatus = 'Closed';
                        this.loadTickets();
                    })
                    .catch(err => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ', err.response?.data || 'فشل الإغلاق');
                    });
            });
        },

        formatDate(value) {
            if (!value) return '';
            return this.$helper.formatDate ? this.$helper.formatDate(value) : new Date(value).toLocaleDateString('ar');
        },

        formatTime(value) {
            if (!value) return '';
            return new Date(value).toLocaleTimeString('ar', { hour: '2-digit', minute: '2-digit' });
        },

        resolveUrl(path) {
            if (!path) return '#';
            if (path.startsWith('http')) return path;
            return path;
        }
    }
};
